let pages = [{
    name: 'List',
    title: '列表'
  },
  {
    name: 'Add',
    title: '添加'
  }
]

let generateItem = (name, title) => {
  return {
    name,
    title,
    items: [...pages]
  }
}

export default [{
    name: 'Basis',
    title: '基础设置',
    items: [
      // generateItem('User', '员工'),
      generateItem('Permission', '权限'),
      generateItem('Role', '角色'),
      generateItem('AppVersion', 'APP版本'),
    ]
  },
  {
    name: 'CMS',
    title: '内容管理',
    items: [
      // generateItem('ArticleCategory', '文章类别'),
      // generateItem('Article', '文章'),
      generateItem('Meidia', '媒体'),
    ]
  },
  {
    name: 'Business',
    title: '配置管理',
    items: [
      generateItem('SearchItem', '搜索引擎配置'),
      generateItem('TVCategory', '电视频道分类'),
      generateItem('TVChannel', '电视频道'),
      generateItem('ThirdPartySite', '外链视频站'),
      generateItem('Advertise', '广告管理'),
      generateItem('Tutorial', '投屏教程'),
      generateItem('About', '关于通久'),
      generateItem('UserComment', '关于通久'),
      generateItem('RegProtocol', '注册协议'),
    ]
  }
]